module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dot",
    on: {
      "click": _vm.showNotificationsClickEvent
    }
  }, [_c('span', {
    staticClass: "dot__text-align"
  }, [_vm._v(_vm._s(_vm.newNotificationCount))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-908889a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/notifications/NotificationPoint.vue
// module id = 1974
// module chunks = 0